<template>
    <div class="recommend animated fadeInUp">
        <div class="title"><i class="iconfont icon-shoucang"></i>精选</div>
        <swiper :options="swiperOption">
            <!-- slides -->
            <swiper-slide class="slide-item" v-for="item in 5">
                <div class="text-position">
                    <div class="recommend-title">
                        这个标题
                    </div>
                    <div class="cate">
                        民间文学 | 公布时间 |类别
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    export default {
        name: "recommend",
        data() {
            return {
                swiperOption: {
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 5,
                    spaceBetween:20,
                    loop:true,
                    autoplay:true,
                    delay:1000
                },
                swiperSlides: [1, 2, 3, 4, 5]
            }
        }
    }
</script>

<style scoped lang="less">
    .recommend {
        width: 80%;
        height: 220px;
        position: absolute;
        bottom: 40px;
        left: 0;
        right: 0;
        margin: auto;
        .title {
            color: #fff;
            font-size: 18px;
            margin-bottom: 5px;
            font-weight: bolder;
        }
    }

    .slide-item {
        background: #fff;
        height: 180px;
        width: 180px;
        border-radius: 10px;
        background: center center no-repeat url('https://ciwei-mall.oss-cn-beijing.aliyuncs.com/image/bg.jpg');
        background-size: cover;
        position: relative;
        color: #fff;
        .text-position{
            position: absolute;
            bottom:15px;
            left: 15px;
        }
        .recommend-title{
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 6px;
        }
        .cate{
            font-size: 12px;
        }
    }
</style>